import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Quote as QuoteIcon } from "lucide-react";
import { IMAGES } from "../lib/content";

export const Quote = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  const lines = [
    { text: "My grandfather taught me that ", accent: "credit is a promise you keep to your future." },
    { text: "My father showed me that ", accent: "wealth is built one disciplined decision at a time." },
  ];

  return (
    <section
      ref={ref}
      data-testid="founder-quote"
      className="relative overflow-hidden bg-[#221b14]"
    >
      <motion.div style={{ y: bgY, scale: 1.2 }} className="absolute inset-0 z-0">
        <img
          src={IMAGES.cityNight}
          alt=""
          className="h-full w-full object-cover opacity-[0.12]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#221b14] via-black/85 to-[#221b14]" />
      </motion.div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(212,175,55,0.09),transparent_60%)]" />

      <div className="relative z-10 mx-auto max-w-[1000px] px-5 sm:px-8 py-28 sm:py-40 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.6, rotate: -8 }}
          whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="flex justify-center"
        >
          <QuoteIcon className="h-14 w-14 text-amber-500/50" fill="currentColor" />
        </motion.div>

        <span className="mt-8 block text-[11px] uppercase tracking-[0.3em] text-amber-500">
          A Legacy Passed Down
        </span>

        <blockquote className="mt-8 font-serif text-2xl sm:text-4xl lg:text-[2.85rem] leading-[1.3] text-zinc-100">
          {lines.map((l, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.15 + i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="block"
            >
              {l.text}
              <span className="text-gold-foil">{l.accent}</span>
            </motion.span>
          ))}
        </blockquote>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.7 }}
          className="mt-14 flex flex-col items-center"
        >
          <span className="h-px w-16 bg-amber-500/50" />
          <p className="mt-6 font-serif italic text-3xl sm:text-4xl text-white">
            Barry Thornton
          </p>
          <p className="mt-2 text-xs uppercase tracking-[0.28em] text-amber-500">
            Founder
          </p>
        </motion.div>
      </div>
    </section>
  );
};
